nbf.str = function(){
	function esEmail(email){
	    var patron = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
	    return (patron.test(email)==true);
	}

	function esUrl(url){
		var patron = new RegExp();
		patron.compile("^[A-Za-z]+://[A-Za-z0-9-]+\.[A-Za-z0-9]+");
		return (patron.test(url)==true);
	}
	
	/**
	 * Pasa el texto pasado a formato fecha YYYY-MM-DD
	 * @param string texto Texto a chequear
	 * @param string formato Formato a leer (por ejemplo %d/%m/%Y, o MM/DD/YYYY HH:II)
	 * @return string Formato de fecha correspondiente, o null en caso d error
	 */
	function textoAFecha(texto,formato){
		var ok = false;
		var val = {"dia":"","mes":"","anyo":"","hora":"","min":"","seg":""};
		var i = 0;
		for(var c=0;c<formato.length;c++){
			if(formato.charAt(c)=="%"){
				c++;
				switch(formato.charAt(c)){
					case "d":
						val.dia = texto.substring(i,i+2);
						if(val.dia>0 && val.dia<=31)
							i += 2;
						else
							return null;
					break;
					case "m":
						val.mes = texto.substring(i,i+2);
						if(val.mes>0 && val.mes<=12)
							i += 2;
						else
							return null;
					break;
					case "Y":
						val.anyo = texto.substring(i,i+4);
						if(val.anyo>1000)
							i += 4;
						else
							return null;
					break;
					case "y":
						val.anyo = texto.substring(i,i+2);
						if(val.anyo>0){
							if(val.anyo>70)
								val.anyo = "19"+val.anyo;
							else
								val.anyo = "20"+val.anyo;
						}else
							return null;
					break;
					case "H":
						val.hora = texto.substring(i,i+2);
						if(val.hora>0 && val.hora<24)
							i += 2;
						else
							return null;
					break;
					case "M":
						val.min = texto.substring(i,i+2);
						if(val.min>0 && val.min<60)
							i += 2;
						else
							return null;
					break;
					case "S":
						val.seg = texto.substring(i,i+2);
						if(val.seg>0 && val.seg<60)
							i += 2;
						else
							return null;
					break;
				}
			}else //saltamos caracter en el texto también
				i++;
		}
		var resp = val.anyo+"-"+val.mes+"-"+val.dia;
		if(val.hora)
			resp += " "+val.hora+":"+(val.min?val.min:"00")+":"+(val.seg?val.seg:"00");
		return resp;
	}

	return {
		"esEmail":esEmail,
		"esUrl":esUrl,
		"textoAFecha":textoAFecha
	};
}();

